import { Alert, Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    fullName: string,
    onConfirm: () => void,
    onCancel: () => void
}

const ConvertToDirectToCenterModal = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Convert to Direct-To-Center
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 20, textAlign: 'center' }}>
                    Confirm that you want to skip the rest of the PWL process for donor <strong>{props.fullName}</strong>...
                </div>

                <Alert bsStyle='warning'>By clicking the confirmation the donor will skip over the rest of the PWL process.</Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConvertToDirectToCenterModal;